<template>
  <div class="layout">
    <JobseekerHeader :item="item" />
    <JobseekerSidebar :item="item" />
    <div class="layout_content">
      <div class="home_name">Available Jobs</div>
      <div class="home_loader" v-if="pageLoading">
        <div>
          <PageLoader />
        </div>
      </div>
      <div class="home_list" v-if="!pageLoading">
        <p v-if="jobs.length === 0">There are currently no available jobs.</p>

        <div class="desktop">
          <div>
            <div v-for="(val, index) in jobs" :key="index">
              <div class="home_list_name">
                <h3>{{ val.title ? val.title : "" }}</h3>
                <p>
                  <font-awesome-icon icon="user" />
                  &nbsp;
                  {{ val.no_of_slots ? val.no_of_slots : "" }} open slots
                </p>
                <span>
                  <font-awesome-icon icon="map-marker-alt" />
                  &nbsp;{{ val.state ? val.state.name : "" }}
                </span>
              </div>
              <div class="home_list_amount">
                &#8358;{{
                  val.salary
                    ? val.salary
                        .toFixed(2)
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    : ""
                }}
              </div>
              <div class="home_list_btn">
                <div
                  class="home_list_btn_click"
                  @click="applyForJob(val.id, index)"
                >
                  Indicate interest
                </div>
                <div class="home_list_btn_loader">
                  <WhiteLoader />
                </div>
                <p class="click__para">
                  <font-awesome-icon icon="clock" />
                  &nbsp;{{ val.daysLeft }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="mobile">
          <div>
            <div v-for="(val, index) in jobs" :key="index">
              <div class="home_list_mobile_details">
                <h4>{{ val.title ? val.title : "" }}</h4>
                <p>
                  (&#8358;{{
                    val.salary
                      ? val.salary
                          .toFixed(2)
                          .toString()
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                      : ""
                  }})
                </p>
                <span>
                  <font-awesome-icon icon="user" />
                  &nbsp;
                  {{ val.no_of_slots ? val.no_of_slots : "" }} open slots
                  <font-awesome-icon icon="map-marker-alt" />
                  &nbsp;{{ val.state ? val.state.name : "" }}
                </span>
              </div>
              <div class="home_list_mobile_btn">
                <div
                  class="home_list_mobile_btn_click"
                  @click="applyForJob(val.id, index)"
                >
                  Indicate interest
                </div>
                <div class="home_list_mobile_btn_loader">
                  <WhiteLoader />
                </div>
                <p class="click__para__mobile">
                  <font-awesome-icon icon="clock" />
                  &nbsp;{{ val.daysLeft }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="home_paginate" v-if="!pageLoading">
        <div v-if="this.paginate.lastPage !== 1">
          <div @click="pagination(paginate.firstPageUrl)">
            1
          </div>
          <div @click="pagination(paginate.prevPageUrl)"><</div>
          <div>{{ paginate.currentPage }}</div>
          <div @click="pagination(paginate.nextPageUrl)">></div>
          <div @click="pagination(paginate.lastPageUrl)">
            {{ paginate.lastPage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import WhiteLoader from "../../partials/white-loader";
import JobseekerHeader from "../../partials/jobseekerheader";
import JobseekerSidebar from "../../partials/jobseekersidebar";

export default {
  name: "JobseekerJobs",
  components: {
    JobseekerHeader,
    JobseekerSidebar,
    PageLoader,
    WhiteLoader
  },
  data() {
    return {
      item: "jobs",
      pageLoading: true,
      btnLoader: false,
      jobs: [],
      paginate: {
        currentPage: "",
        currentPath: "",
        lastPage: "",
        firstPageUrl: "",
        lastPageUrl: "",
        prevPageUrl: "",
        nextPageUrl: ""
      }
    };
  },
  metaInfo: {
    title: 'HR Desk Job Listings - Find Your Next Career Opportunity',
    meta: [
      { name: 'description', content: 'Browse the latest job listings on HR Desk. Find your next career opportunity in human resources, recruitment, and more.' },
      { property: 'og:title', content: 'HR Desk Job Listings - Find Your Next Career Opportunity' },
      { property: 'og:description', content: 'Browse the latest job listings on HR Desk. Find your next career opportunity in human resources, recruitment, and more.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://app.hrdesk.africa/settings' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'HR Desk Job Listings - Find Your Next Career Opportunity' },
      { name: 'twitter:description', content: 'Browse the latest job listings on HR Desk. Find your next career opportunity in human resources, recruitment, and more.' },
      { name: 'twitter:image:alt', content: 'Settings at hrdesk' },
      { name: 'keywords', content: 'company settings, HR customization, HR policies, company information management, HR system configuration job listings, HR careers, recruitment jobs, HR job opportunities, find a job' },
    ]
  },
  methods: {
    getJobs(val) {
      let url;
      if (val) {
        url = val;
      } else {
        url = types.GET_JOBS;
      }

      this.paginate.currentPath = url;

      this.$http.get(url).then(resp => {
        this.jobs = [...resp.data.data.data];

        this.paginate.currentPath = resp.data.data.first_page_url;

        this.paginate.firstPageUrl = resp.data.data.first_page_url;
        this.paginate.lastPageUrl = resp.data.data.last_page_url;

        this.paginate.prevPageUrl = resp.data.data.prev_page_url;
        this.paginate.nextPageUrl = resp.data.data.next_page_url;

        this.paginate.currentPage = resp.data.data.current_page;
        this.paginate.lastPage = resp.data.data.last_page;

        for (let index = 0; index < this.jobs.length; index++) {
          const noOfdays = this.calculate(this.jobs[index].expiry_date);
          this.jobs[index].daysLeft = noOfdays;
        }

        this.pageLoading = false;
      });
    },
    pagination(val) {
      if (val !== this.paginate.currentPath) {
        if (val) {
          this.pageLoading = true;
          this.getJobs(val);
        }
      }
    },
    applyForJob(val, index) {
      const clickBtn = document.getElementsByClassName("home_list_btn_click");
      const loaderBtn = document.getElementsByClassName("home_list_btn_loader");
      const clickBtnParagraph = document.getElementsByClassName("click__para");
      const clickBtnParagraphMobile = document.getElementsByClassName(
        "click__para__mobile"
      );
      const mobileBtn = document.getElementsByClassName(
        "home_list_mobile_btn_click"
      );
      const mobileloaderBtn = document.getElementsByClassName(
        "home_list_mobile_btn_loader"
      );

      clickBtn[index].style.display = "none";
      loaderBtn[index].style.display = "block";
      mobileBtn[index].style.display = "none";
      mobileloaderBtn[index].style.display = "block";

      this.$http
        .post(types.JOB_APPLY, {
          job_listing_id: val
        })
        .then(resp => {
          clickBtn[index].style.display = "none";
          loaderBtn[index].style.display = "none";
          mobileBtn[index].style.display = "none";
          mobileloaderBtn[index].style.display = "none";
          clickBtnParagraph[index].style.display = "none";
          clickBtnParagraphMobile[index].style.display = "none";
        })
        .catch(err => {
          // console.log(err.response.data.message);
          clickBtn[index].style.display = "none";
          loaderBtn[index].style.display = "none";
          mobileBtn[index].style.display = "none";
          mobileloaderBtn[index].style.display = "none";
          clickBtnParagraph[index].style.display = "none";
          clickBtnParagraphMobile[index].style.display = "none";
        });
    },
    calculate(val) {
      const oneDay = 24 * 60 * 60 * 1000;

      let today = new Date();
      let toDayYear = today.getUTCFullYear();
      let toDayMonth = today.getMonth();
      let toDayDate = today.getDate();
      let setDate = val;
      let num = setDate.split("-");
      let setYear = num[0];
      let setMonth = num[2] - 1;
      let setDay = num[1];

      const firstDate = new Date(toDayYear, toDayMonth, toDayDate);
      const secondDate = new Date(setYear, setMonth, setDay);

      if (firstDate > secondDate) {
        return "Job closed";
      }
      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));
      return `${diffDays} days left`;
    }
  },
  created() {
    this.getJobs();
  }
};
</script>

<style lang="scss" scoped>
.layout {
  background-color: #fbfafa;
  min-height: 1000px;

  > .layout_content {
    padding-top: 120px;
    padding-left: 250px;
    padding-right: 50px;

    @media (max-width: 1000px) {
      padding-left: 10px;
      padding-right: 10px;
    }

    > .home_name {
      font-size: 16px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      text-align: left;
      color: #f79320;
    }

    > .home_loader {
      padding-top: 30px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      align-content: center;
      min-height: 200px;

      > div {
        width: 55px;
      }
    }

    > .home_list {
      margin: 30px 0;
      min-height: 200px;

      > h4 {
        font-size: 30px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.78;
        letter-spacing: normal;
        text-align: center;
        color: #000;

        > span {
          font-weight: 600;
        }
      }

      > p {
        text-align: center;
        font-size: 14px;
        color: #000;
        margin-top: 20px;
      }

      > .desktop {
        margin-top: 10px;
        padding: 10px;
        overflow: auto;

        @media (max-width: 500px) {
          display: none;
        }

        > div {
          > div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            border-radius: 2px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            border: solid 1px #dddddd;
            background-color: #ffffff;
            padding: 20px 10px;
            width: 100%;
            max-width: 800px;
            margin: 50px auto 0 auto;

            > .home_list_name {
              width: 33.3333333%;

              > h3 {
                font-size: 14px;

                font-weight: bold;

                font-stretch: normal;

                font-style: normal;

                line-height: 1.36;

                letter-spacing: normal;

                text-align: left;

                color: #000000;
              }

              > p {
                font-size: 12px;

                font-weight: 300;

                font-stretch: normal;

                font-style: normal;

                line-height: 1.27;

                letter-spacing: normal;

                text-align: left;

                color: #000000;
                margin: 5px 0;
              }

              > span {
                font-size: 12px;

                font-weight: 300;

                font-stretch: normal;

                font-style: normal;

                line-height: 1.27;

                letter-spacing: normal;

                text-align: left;

                color: #000000;
              }
            }

            > .home_list_amount {
              width: 33.3333333%;
              font-size: 16px;
              font-weight: 600;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.17;
              letter-spacing: normal;
              text-align: center;
              color: #f79320;
            }

            > .home_list_btn {
              width: 33.3333333%;

              > .home_list_btn_loader {
                display: none;
              }

              > div {
                width: 80%;
                height: 40px;
                border-radius: 5px;
                box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
                background-color: #f79320;
                font-size: 13px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 2.22;
                letter-spacing: normal;
                text-align: center;
                color: #ffffff;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                align-content: center;
                margin: auto;
                cursor: pointer;
                margin-bottom: 10px;
              }

              > p {
                font-size: 14px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.33;
                letter-spacing: normal;
                text-align: center;
                margin: 0;
                color: #f17d6b;
              }
            }
          }
        }
      }

      > .mobile {
        margin-top: 10px;
        padding: 10px;
        overflow: auto;
        display: none;

        @media (max-width: 500px) {
          display: block;
        }

        > div {
          > div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            border-radius: 2px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            border: solid 1px #dddddd;
            background-color: #ffffff;
            padding: 20px 10px;
            width: 100%;
            margin: 50px auto 0 auto;

            > .home_list_mobile_details {
              width: calc(100% - 200px);

              @media (max-width: 450px) {
                width: 50%;
              }

              > h4 {
                font-size: 15px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.33;
                letter-spacing: normal;
                color: #000000;
              }

              > p {
                font-size: 16px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.17;
                letter-spacing: normal;
                text-align: left;
                color: #f79320;
                margin: 5px 0;
              }

              > span {
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.22;
                letter-spacing: normal;
                text-align: left;
                color: #777;
              }
            }

            > .home_list_mobile_btn {
              width: 200px;

              @media (max-width: 450px) {
                width: 50%;
              }

              > .home_list_mobile_btn_loader {
                display: none;
              }

              > div {
                width: 80%;
                height: 40px;
                border-radius: 5px;
                box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
                background-color: #f79320;
                font-size: 13px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 2.22;
                letter-spacing: normal;
                text-align: center;
                color: #ffffff;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                align-content: center;
                margin: 0 auto 10px auto;
                cursor: pointer;
              }

              > p {
                font-size: 14px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.33;
                letter-spacing: normal;
                text-align: center;
                margin: 0;
                color: #f17d6b;
              }
            }
          }
        }
      }
    }

    > .home_paginate {
      margin-bottom: 100px;

      > div {
        width: 300px;
        margin: auto;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-content: center;
        align-items: center;
        overflow: hidden;

        > div {
          width: 20%;
          height: 40px;
          border: 1px solid #ccc;
          cursor: pointer;
          display: flex;
          flex-flow: row nowrap;
          justify-content: center;
          align-content: center;
          align-items: center;
          color: #777777;
        }
      }
    }
  }
}
</style>
